import { render, staticRenderFns } from "./msgBoxList.vue?vue&type=template&id=57faba15&scoped=true&"
import script from "./msgBoxList.vue?vue&type=script&lang=js&"
export * from "./msgBoxList.vue?vue&type=script&lang=js&"
import style0 from "./msgBoxList.vue?vue&type=style&index=0&id=57faba15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57faba15",
  null
  
)

export default component.exports